/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import ReactFileReader from 'react-file-reader';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@jem-open/jem-ui';
import axios from 'axios';
import Swal from 'sweetalert2';
import { readString } from 'react-papaparse';
import { CsvPreviewTable } from '../../../components/CsvPreviewTable';
import apiResponseHandler from '../../../utils/apiResponseHandler';
import { environment } from '../../../environment/environment';
import { localStorageService } from '../../../services';

const AdvancePaymentFileUploadModal = (props) => {
  const [state, setState] = useState({
    csvData: null,
    file: null,
  });
  const [loading, setLoading] = useState(false);

  const { showAdvancePaymentFileUploadModalModal, onUploaded } = props;

  const closeModal = () => showAdvancePaymentFileUploadModalModal(false);

  const renderPreview = () => {
    if (loading) {
      return (
        <div className="flex justify-center py-lg">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      );
    }
    if (!state.csvData) {
      return (
        <div className="flex justify-center py-lg text-sm text-greyscale-text-body">
          No file loaded
        </div>
      );
    }
    return (
      <div className="table-responsive">
        <CsvPreviewTable
          data={state.csvData || ''}
          csvDelimiter=","
          tableClassName="table table"
          responsive
        />
      </div>
    );
  };

  const handleFiles = (files) => {
    setLoading(true);
    const reader = new FileReader();
    reader.onload = () => {
      setState({
        csvData: reader.result,
        markAsPaidIds: readString(reader.result, { header: true })
          .data.filter((item) => item['Statement Reference'])
          .map((item) => item['Statement Reference'].split('-')[1]),
        file: files[0],
      });
      setLoading(false);
    };
    reader.readAsText(files[0]);
  };

  const handleAdvancePaymentFileUploadSubmit = () => {
    const user = localStorageService.getUserOrThrow();
    const currentUserId = user.id;

    if (state.file === null) {
      Swal.fire({
        title: 'Oops...',
        text: 'Please upload a file to upload',
        icon: 'error',
      });
    } else {
      Swal.fire({
        title: 'Uploading payment file',
        willOpen: () => {
          Swal.showLoading();
        },
      });
      const headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
      };

      const bodyFormData = new FormData();
      bodyFormData.append('advance_payment_file', state.file);
      bodyFormData.append('uploaded_by', currentUserId);

      axios
        .post(
          `${environment.baseUrl}/advancepaymentfileprocessingjob/`,
          bodyFormData,
          { headers },
        )
        .then(() => {
          Swal.fire({
            title: 'Upload complete',
            html: ``,
            icon: 'success',
          });
          onUploaded();
          closeModal();
        })
        .catch((error) => {
          apiResponseHandler.handleApiError('Error', error);
        });
    }
  };

  return (
    <Dialog
      open
      onOpenChange={(next) => {
        if (!next) closeModal();
      }}>
      <DialogContent className="flex max-h-[85vh] flex-col sm:max-w-4xl">
        <DialogHeader>
          <DialogTitle>Upload Advance Payment File</DialogTitle>
        </DialogHeader>

        <div className="min-h-0 flex-1 overflow-y-auto">{renderPreview()}</div>

        <DialogFooter className="flex items-center justify-between sm:justify-between">
          <ReactFileReader
            multipleFiles={false}
            fileTypes={['.csv']}
            handleFiles={handleFiles}>
            <Button type="button" variant="outline">
              {state.file ? 'Choose different file' : 'Choose file'}
            </Button>
          </ReactFileReader>
          <div className="flex items-center gap-xs">
            <Button type="button" variant="outline" onClick={closeModal}>
              Cancel
            </Button>
            <Button
              type="button"
              variant="approve"
              disabled={!state.file}
              onClick={handleAdvancePaymentFileUploadSubmit}>
              Mark all as paid
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

AdvancePaymentFileUploadModal.defaultProps = {
  onUploaded: () => {},
};

AdvancePaymentFileUploadModal.propTypes = {
  showAdvancePaymentFileUploadModalModal: PropTypes.func.isRequired,
  onUploaded: PropTypes.func,
};

export default AdvancePaymentFileUploadModal;
